<template>
  <div id="app" >
    <Sidebar/>
    <router-view/>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'

export default {
  name: 'app',
  components: {
    Sidebar
  },
  computed: {
    currentUserClaims () {
      return (Object.keys(this.$store.state.currentUserClaims).length > 0)
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
.material-icons {
  color: #FFFFFF50
}
html,body,
  #app{
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    display: flex;
  }
  body {
    color: #FFFFFF;
    background-color: #2E303A;
    font-family: 'Roboto', sans-serif;
  }
  h1, h2, h3 {
    margin: 0px;
  }
  textarea, select, input, button, video {
    outline: none;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0px 7px;
    min-height: 30px;
    background-color: #2E303A;
    color: #D5D5D7;
    border: 1px solid #FFFFFF20;
    border-radius: 5px;
    height: 30px;
  }
  input, textarea {
    padding: 5px 7px;
    background-color: #2E303A;
    border: 1px solid #FFFFFF20;
    color: #FFFFFF;
    min-height: 30px;
    border-radius: 5px;
    box-sizing: border-box;
    &:focus {
      outline: none;
    }
  }
  .dg-content {
    color: black !important;
  }
  input {
    height: 30px;
  }
  button {
    cursor: pointer;
  }
  .icon-button {
    cursor: pointer;
  }
  a:visited {
    color: inherit;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  .clickable {
    cursor: pointer;
  }
  .router-link-active {
    cursor: pointer;
  }
  .inactiveLink {
    cursor: default;
  }
  .contentBox {
    background-color: #333746;
    border-radius: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, .2);
    display: flex;
    flex-wrap: wrap;
    overflow-y:auto;
  }
  .outlineButton {
    height: 30px;
    background-color: inherit;
    border-color: #FFFFFF50;
    color: white;
    border-radius: 3px;
    padding: 0px 15px;
    cursor: pointer;
  }
  .dg-backdrop {
    background-color: #2E303A !important;
    opacity: .8 !important;
  }
  .dg-main-content {
    font-family: 'Roboto';
    background-color: #333746 !important;
    box-shadow: 0px 2px 5px #00000014;
    .dg-content-body {
      border-bottom: 2px solid #2E303A !important;
      .dg-content {
        color: #FFFFFF !important;
      }
    }
    .dg-btn {
      font-weight: normal;
      &.dg-btn--cancel {
        background-color: #6A7CE9;
      }
      &.dg-btn--ok {
        background: none;
        color: #FFFFFF;
        border: 1px solid #FFFFFF50;
      }
    }



  }
</style>
<style src="vuejs-dialog/dist/vuejs-dialog.min.css">
</style>
